module.exports = __webpack_public_path__ + "img/Number=40.f156b922.png";